import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The full path of the TSCN node being rendered, such as "World/Hallway/Lamp".
 * Only the NodeDispatcher knows it, so it provides this for each child, and a
 * component tags its three.js objects with it.
 */
import { createContext, useContext } from 'react';
const NodePathContext = createContext(null);
NodePathContext.displayName = 'NodePathContext';
export function NodePathProvider({ path, children }) {
    return _jsx(NodePathContext.Provider, { value: path, children: children });
}
/** The path of the nearest enclosing TSCN node, or `null` outside the dispatcher. */
export function useNodePath() {
    return useContext(NodePathContext);
}
//# sourceMappingURL=NodePathContext.js.map